module.exports = __webpack_public_path__ + "static/media/diamond-icon.7d869fd6.svg";